/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AdditionalResourceDetailsForFinopsBillingAzureAdvisor extends models.AdditionalResourceDetailsForFinopsReservationRecommendations {
    constructor() {
        super();
        this.setDiscriminator("AdditionalResourceDetailsForFinopsBillingAzureAdvisor");
    }

    getFixupPrototypeFunction() { return AdditionalResourceDetailsForFinopsBillingAzureAdvisor.fixupPrototype; }

    static newInstance(model: Partial<AdditionalResourceDetailsForFinopsBillingAzureAdvisor>): AdditionalResourceDetailsForFinopsBillingAzureAdvisor {
        let obj = Object.assign(new AdditionalResourceDetailsForFinopsBillingAzureAdvisor(), model);
        AdditionalResourceDetailsForFinopsBillingAzureAdvisor.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AdditionalResourceDetailsForFinopsBillingAzureAdvisor>): AdditionalResourceDetailsForFinopsBillingAzureAdvisor {
        if (!model) return null;
        return AdditionalResourceDetailsForFinopsBillingAzureAdvisor.newInstance(<AdditionalResourceDetailsForFinopsBillingAzureAdvisor> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AdditionalResourceDetailsForFinopsBillingAzureAdvisor) {
        if (!obj) return;

        models.AdditionalResourceDetailsForFinopsBillingAzureAdvisor.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AdditionalResourceDetailsForFinopsBillingAzureAdvisor): boolean {
        if (models.AdditionalResourceDetailsForFinopsReservationRecommendations.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AdditionalResourceDetailsForFinopsBillingAzureAdvisor.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
